import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FieldConfig} from '../field.interface';

@Component({
    selector: 'app-attachment',
    template: `
    <button mat-raised-button color="default" (click)="inputFile.click()"
      style="width: 100%; height: 46px; margin-top: 3px" matTooltip="Upload associated file" type="button">
      <mat-icon>attach_file</mat-icon>
      @if (fileUploadedName) {
        <span> {{ fileUploadedName }}</span>
      } @else {
        {{ field.label }}
      }
    </button>
    <input hidden mat-raised-button color="default" #inputFile (change)="onFileSelected($event)"
      [accept]="field.acceptType" type="file"/>
    `,
    styles: [],
    standalone: false
})
export class AttachmentComponent implements OnInit {
  @Output() attachedValue = new EventEmitter();
  field: FieldConfig;
  group: UntypedFormGroup;
  fileUploadedName: string;
  selectedFile: string | ArrayBuffer;
  // @HostBinding('class') rowClass = 'col-md-6';
  constructor() { }

  ngOnInit() {
  }

  onFileSelected(event) {

    const file = event.target.files[0];
    const fileUploadedNameData = file.name;
    if (fileUploadedNameData.length > 58) {
      this.fileUploadedName = fileUploadedNameData.slice(0, 58) + '...';
    } else {
      this.fileUploadedName = fileUploadedNameData;
    }
    const fileReader: FileReader = new FileReader();
    const self = this;
    fileReader.onloadend = (x) => {
      const attachmentFile = {"filename": this.fileUploadedName, "data": fileReader.result};
      self.group.controls[this.field.key].setValue(attachmentFile);
      this.attachedValue.emit({ attachmentFile, field: this.field });
    };
    fileReader.readAsDataURL(file);
  }

}
